import React from 'react';
import { FaPlay, FaPause } from 'react-icons/fa';

const faStyle = 'ml-2 pl-1 panel-svg';
const PlayButton = <FaPlay className={faStyle} />;
const PauseButton = <FaPause className={faStyle} />;

const PlayPauseButton = ({ handleClick, item, isPlaying, text, className }) => (
    <button onClick={() => handleClick(item)} className={className}>
        {text}
        {isPlaying ? PauseButton : PlayButton}
    </button>
);

export default PlayPauseButton; 